import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import UserLayout from '@/pages/users/UserLayout.vue';
import UserEditPage from '@/pages/users/UserEditPage.vue';
import { createRoutes } from '@/utils/router-helper';
import { canEditUserGuard } from '@/utils/route-guards';

export default createRoutes({
  path: 'user',
  component: UserLayout,
  beforeEnter: [authGuard, canEditUserGuard],
  children: [
    {
      path: '',
      alias: '/pay-vendors/business-profile/owners/:id/step-one',
      name: RouteNames.USER.INDEX,
      component: UserEditPage,
    },
  ],
});
